export default __webpack_public_path__ + "static/media/sikom-black.d8280a7a.png";